import $ from "jquery";

$('.unit-info_dropdown').on('click', function(){
    var $li = $(this).parent();
    if($li.hasClass('active')) {
      $li.removeClass('active');
    } else {
      $li.addClass('active');
    }
});



        $(".floorplan-image").click(function(){
            $("#popup-image").attr("src", $(this).attr("src"));
            $("#popup-container").fadeIn();
        });

        $(".close-popup").click(function(){
            $("#popup-container").fadeOut();
        });